import store from "@/store";
import { setStore } from "@/util/store";
import { convertToRoute, convertToMenu } from "@/util/util";
import { menu } from "@/mock/menu";
/**
 * 加载用户缓存
 * token
 * userInfo
 * companyId
 * currentCompany
 * @param {Object} userDetail - 用户详情对象
 */
export async function loadUserCache(userDetail) {
  console.log(userDetail)
  await store.dispatch("setUserInfo", userDetail);
  // if (userDetail && userDetail.account && userDetail.account.companyId) {
  //   if (store._actions && store._actions.setCurrentCompany) {
  //     await store.dispatch("setCurrentCompany", userDetail.account.companyId);
  //   }
  // }
  setStore({ name: "foreign_userinfo", content: userDetail });
}

export async function loadMenuCache(menuList) {
  // 转换为路由和菜单格式
  let routes = convertToRoute(menuList);
  let menus = convertToMenu(menuList);
  if (!menus.length) {
    return Promise.reject({ message: "您没有该应用权限,请联系管理员", redirect: "/login" });
  }
  setStore({ name: "foreign_menu", content: menuList });
  // 存储到store中
  await store.dispatch("setRoute", routes);
  await store.dispatch("setMenu", menus.concat(menu));
}